import { motion, AnimatePresence } from 'framer-motion';

const BackButton = ({ onClick, isChatActive }) => {
  return (
    <AnimatePresence>
      {isChatActive && (
      <motion.button
        className="back-button"
        onClick={onClick}
        initial={{ opacity: 0, display: 'none' }}
        animate={isChatActive ? { opacity: 1, display: 'block' } : { opacity: 0, transitionEnd: { display: 'none' } }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      />
      )}
    </AnimatePresence>
  );
};

export default BackButton;